import { render, staticRenderFns } from "./standardCreation.vue?vue&type=template&id=60dbb4d3&scoped=true"
import script from "./standardCreation.vue?vue&type=script&lang=js"
export * from "./standardCreation.vue?vue&type=script&lang=js"
import style0 from "./standardCreation.vue?vue&type=style&index=0&id=60dbb4d3&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../../../../../../../../../opt/build-cache/ad/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60dbb4d3",
  null
  
)

export default component.exports